<template>
  <div class="main-canvas" style="">
    <b-button @click="$forceUpdate()" />
    <div class="row" v-for="(v, i) in itms" :key="v.id">
      <div class="col p-2">
        <b-input v-model="itms[i].va" value="itms[i].va" />
        <div class="main-canvas" style="">
          <div class="row" v-for="(v, i) in items" :key="i">
            <div class="col p-2">
              <AkCurrencyField v-model="v.va" />
            </div>
            <!--
      <div class="col p-2">
        <input type="number" v-model.number="numValue" />
      </div>-->
          </div>
          <div class="form-group">
            <div class="input-icon">
              <b-form-input type="text" class="form-control" placeholder="0.00" />
              <i class="text-grey">€</i>
            </div>
          </div>
          <div class="form-group">
            <input
              type="number"
              v-model.number="theValue"
              class="form-control"
              placeholder="0,00"
              pattern="[0-9]{4}"
              @change="toCurrency('theValue')"
            />
          </div>
          <div class="form-group">
            <div class="input-icon input-icon-right">
              <b-form-input type="text" class="form-control" placeholder="0.00" />
              <i class="text-grey">m³</i>
            </div>
          </div>
          <div class="inputwithicon">
            <b-form @submit.stop.prevent inline class="mb-3">
              <b-button size="sm" @click="loading = !loading" style="width:150px;" class="mr-2">
                <span v-if="!loading">Längerer Button</span>
                <b-spinner small v-if="loading" label="Spinning"></b-spinner>
              </b-button>
              <b-button size="sm" @click="toggleAll" class="mr-2">Toggle</b-button>
              <b-button size="sm" @click="search" class="mr-2">Search</b-button>
              <b-form-input type="text" v-model="searchText" debounce="300" @update="search" @keyup.enter="search" />
            </b-form>
          </div>
          <b-table :items="items" :fields="fields" :responsive="true">
            <template #head(Bezeichnung)="data">
              <div style="min-width:200px">{{ data.label }}</div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import AkCurrencyField from '@/components/AkCurrencyField';
export default {
  components: {
    //  AkCurrencyField
  },
  mounted() {
    var that = this;
    var rndNr = 1;
    for (var i = 0; i < 10; i++) {
      that.items.push({
        Id: rndNr,
        Bezeichnung: 'Vergabeeinheit ' + rndNr++,
        Budget: 30000,
        Status: 'Offen',
        Feld: 'Wert',
        checked: false
      });
    }
  },
  data() {
    return {
      checkedAll: false,
      loading: false,
      items: [
        { id: 1, va: 3 },
        { id: 2, va: 7 },
        { id: 3, va: 2 },
        { id: 4, va: 1 }
      ],
      theValue: 1,
      numValue: 1,
      itms: [
        { id: 1, va: 3 },
        { id: 2, va: 7 },
        { id: 3, va: 1 },
        { id: 4, va: 6 }
      ],
      fields: [
        { key: 'checked', label: '' },
        { key: 'Id', label: 'VE' },
        { key: 'Bezeichnung', label: 'Bezeichnung', thStyle: 'resize: horizontal;' },
        { key: 'Budget', label: 'Budget', thStyle: 'min-width:150px;' },
        { key: 'Status', label: 'Status', thStyle: 'min-width:150px;' },
        { key: 'Feld', label: 'Feld', thStyle: 'min-width:150px;' },
        { key: 'Budget2', label: 'Budget', thStyle: 'min-width:150px;' },
        { key: 'Status2', label: 'Status', thStyle: 'min-width:150px;' },
        { key: 'Feld2', label: 'Feld', thStyle: 'min-width:150px;' },

        { key: 'Actions', label: 'Aktionen', thStyle: 'min-width:150px;' }
      ],
      searchText: '',
      highlightedRow: 0
    };
  },
  methods: {
    toCurrency(field) {
      this[field] = parseFloat(this[field]).toFixed(2);

      //return field;
      //parseFloat(theValue).toFixed(2)
    },
    handleTabA() {
      console.log('handleTabA');
    },
    handleTabB() {
      console.log('handleTabB');
    },

    toggleAll() {
      this.checkedAll = !this.checkedAll;
      this.items.map(x => {
        x.checked = true;
        this.$refs['cb-' + x.Id].checked = this.checkedAll;
        return x;
      });
    },
    handleChange(evt) {
      console.log(evt);
    },
    makeVisible(item) {
      const field = document.getElementById('bezeichnungField-' + item.Id);
      console.log('display', field.style.display);
      if (field.style.display == 'none') {
        console.log('making it visible');
        field.style.display = 'block';
        field.focus();
      } else {
        field.style.display = 'none';
      }
      console.log('c');
    },
    search() {
      if (this.highlightedRow > 0)
        document.getElementById('bezeichnungDiv-' + this.highlightedRow).parentElement.parentElement.style.background =
          'inherit';
      const foundItem = this.items.find(x => x.Bezeichnung.includes(this.searchText));

      const row = document.getElementById('bezeichnungDiv-' + foundItem.Id);

      row.scrollIntoView({ block: 'center', behavior: 'smooth' });
      // backup current background before chaning, so we can resotre it
      row.parentElement.parentElement.style.background = 'rgba(128,176,183,.1)';
      this.highlightedRow = foundItem.Id;
    }
  }
};
</script>

<style>
.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 30px;
  text-align: center;
  font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
  padding-right: 0;
}

.input-icon-right > i {
  margin-top: 1px;
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 29px;
  text-align: right;
}
</style>
